module.exports = __webpack_public_path__ + "a4dff8f5510fe3c2f0671273671c2788.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/widget-icons/confetti.png
// module id = 3488
// module chunks = 0